import type { ArticleDoc } from './doc';

/** Concatenate every text node — more accurate than a regex over markdown. */
export function textFromDoc(doc: ArticleDoc | null | undefined): string {
  const parts: string[] = [];
  const walk = (node: unknown): void => {
    if (!node || typeof node !== 'object') return;
    const n = node as { type?: string; text?: string; content?: unknown[] };
    if (n.type === 'text' && typeof n.text === 'string') parts.push(n.text);
    if (Array.isArray(n.content)) n.content.forEach(walk);
  };
  walk(doc);
  return parts.join(' ');
}

export function wordCountFromDoc(doc: ArticleDoc | null | undefined): number {
  const text = textFromDoc(doc).trim();
  if (!text) return 0;
  return text.split(/\s+/).filter(Boolean).length;
}

export function readingMinutesFromDoc(doc: ArticleDoc | null | undefined): number {
  return Math.max(1, Math.round(wordCountFromDoc(doc) / 250));
}
